export default function RootLayout({ children }) {
    return <div className="min-h-screen">{children}</div>
  }
  